import {
	CreateDrawerFormProps,
	FormDrawer,
	FormDrawerContent,
	PagedMultiSelectField,
	Separator,
	TextField,
	laravelSelectFetchConfig,
} from "@dgs/core";
import { FC, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router";
import { DistributionListSelectField } from "../../../distributionLists";
import { createInvitationListService } from "../../../shared/api/invitationListService";
import { getFullNameFromContactOption } from "../../../shared/select/ContactSelectField";
import {
	IAttendancePrediction,
	IInvitationListAttachMultiContactsFormState,
} from "../../../shared/types/invitationList";
import { AttendanceSelectField } from "./AttendanceSelectField";

export const InvitationListAttachMultiContactsDrawer: FC<
	CreateDrawerFormProps<IInvitationListAttachMultiContactsFormState>
> = (props) => {
	const { t } = useTranslation();
	const initialValues: IInvitationListAttachMultiContactsFormState = {
		distributionList: null,
		contacts: [],
		personCount: 1,
		attendancePrediction: "will_attend" as IAttendancePrediction,
	};
	const { eventId = "" } = useParams<"eventId">();
	const service = useMemo(() => createInvitationListService(eventId), [eventId]);

	return (
		<FormDrawer
			{...props}
			initialValues={initialValues}
			title={t("Add contacts to invitation list")}
			validate={({ distributionList, ...values }) => {
				const errors: { [K in keyof IInvitationListAttachMultiContactsFormState]?: any } = {};

				if (!values.personCount) {
					errors.personCount = t("Required field");
				}
				if (values.personCount < 0) {
					errors.personCount = t("The value has to be greater than 0");
				}
				if (!distributionList && !values.contacts.length) {
					errors.distributionList = t("Required field");
					errors.contacts = t("Required field");
				}
				return errors;
			}}
			renderForm={({ formik: { values, setFieldValue }, ...props }) => (
				<FormDrawerContent {...props}>
					<PagedMultiSelectField
						{...props}
						name="contacts"
						label={t("Contacts")}
						disabled={!!values.distributionList}
						onChange={() => setFieldValue("distributionList", null)}
						fetchConfig={laravelSelectFetchConfig(service.contactOptionsKey, (search, page) =>
							service.contactOptions(search, page).then((r) => r.data),
						)}
						getLabel={getFullNameFromContactOption}
					/>
					<DistributionListSelectField
						name="distributionList"
						label={t("Distribution list")}
						disabled={!!values.contacts.length}
						onChange={() => setFieldValue("contacts", [])}
					/>
					<Separator style={{ marginBottom: 12 }} />
					<TextField name="personCount" label={t("Person count")} type="number" />
					<AttendanceSelectField />
				</FormDrawerContent>
			)}
		/>
	);
};
